import { Outlet } from 'react-router-dom'
import React, { useLayoutEffect } from 'react'
import { Stack } from '@mui/material'
import { PageLayout } from '../../../components/PageLayout'
import { EventsTabs } from '../../../components/Events/EventsTabs'
import { PushNotificationsOptIn } from '../../../components/Notifications/PushNotificationsOptIn'
import { useMarkAllNotificationsReadMutation } from '../../../api/notifications'

export const EventsLayout = () => {
  const [markAllRead] = useMarkAllNotificationsReadMutation()
  const didMarkAllRef = React.useRef(false)

  useLayoutEffect(() => {
    document.title = 'События'
  }, [])

  React.useEffect(() => {
    if (didMarkAllRef.current) return
    didMarkAllRef.current = true

    markAllRead()
      .unwrap()
      .catch(() => {
        didMarkAllRef.current = false
      })
  }, [markAllRead])

  return (
    <PageLayout
      title="События"
      topComponent={
        <Stack gap={0}>
          <EventsTabs />
          <PushNotificationsOptIn />
        </Stack>
      }
      mainComponent={<Outlet />}
    />
  )
}
